import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * Volver a mandar a facturar (fn_reintentar_facturacion, 0259): la MISMA fila
 * de la cola vuelve a 'pending' —nunca una segunda fila para la misma COT—.
 * La base no deja reintentar los errores que no se arreglan así.
 */
export function useReintentarFacturacion() {
  const cliente = useQueryClient()
  return useMutation({
    mutationFn: async (cotizacionId: string) => {
      const { error } = await supabase.rpc('fn_reintentar_facturacion', {
        p_cotizacion_id: cotizacionId,
      })
      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({ queryKey: ['alistamientos'] })
    },
  })
}
